import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiploma } from '@fortawesome/pro-duotone-svg-icons';
import BreadCrumbs from './BreadCrumbs';
import HeaderComponent from './HeaderComponent';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import HigherEd from "../assets/images/higher_ed.svg";
import HigherEdCash from "../assets/images/higher_ed_cash.svg";
import '../assets/styles/main.css';

const HigherEducationSubpage = () => {
  return (
    <div className="higher-education" id="higher-education">
      <HeaderComponent />
      <FeatureNav />
      <BreadCrumbs />
      <section className="mt-20">
        <div className="text-center mb-4">
          <h1 className="display-5 fw-bold mb-3">Higher Education</h1>
        </div>
        <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
          <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
            <h3 className="text-light">
              <FontAwesomeIcon icon={faDiploma} className="me-2" />
              Higher Education
            </h3>
            <p className="lead">Use these tools to examine annual financial report data from Institutions of Higher Education </p>
          </div>

          <div className="col-12 bg-light ">
            <div className="row justify-content-center px-3">
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="https://transparent.utah.gov//he-cash/" title="Higher Education">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education - Cash <sup><span
                    className="badge badge-info">New</span></sup></div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={HigherEdCash}
                    data-holder-rendered=" true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">View Cash, Cash Equivalents, and Cash Flows in Higher Education </p>
                  </div>
                </a>
              </article>

              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank"
                  rel="noopener noreferrer" href="/higher-education/higher-education-expenditure" title="Higher Education">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education Expenditure <sup><span
                    className="badge badge-info">New</span></sup></div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={HigherEd}
                    data-holder-rendered=" true" />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Explore how public funds are appropriated in Utah's Higher Education
                      System </p>
                  </div>
                </a>
              </article>
            </div>
          </div>
        </div>
      </section>
      <FooterSection />
    </div>
  )
}

export default HigherEducationSubpage;